const Categories = [
    { category: "Films", value: 10, disabled: false,
      icon: "images/film-icon.png", json: "/data/MovieQuestions.json"
     },
    { category: "Television", value: 11, disabled: false,
      icon: "images/tv-icon.png", json: "/data/TVQuestions.json"
    },
    { category: "Video Games", value: 9, disabled: false,
      icon: "images/game-icon.png", json: "/data/VGQuestions.json"
    }
  ];
  
  export default Categories;